import { render, staticRenderFns } from "./VideoStreamFlv.vue?vue&type=template&id=50a8f1f4"
import script from "./VideoStreamFlv.vue?vue&type=script&lang=js"
export * from "./VideoStreamFlv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports